import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import { styleEntry } from '@mylighthouse/prism-ember';

import styles from './edit-cell-popover.module.css';

interface HotelChannelPricingEditCellPopoverSignature {
  Args: {
    onPopoverToggle: (event: ToggleEvent) => void;
    popoverId: string;
  };
  Blocks: {
    default: [];
  };
}

const HotelChannelPricingEditCellPopover = <template>
  <div
    class="edit-cell-popover {{styles.popover}}"
    id={{@popoverId}}
    popover
    style={{styleEntry "position-anchor" (concat "--" @popoverId)}}
    {{on "toggle" @onPopoverToggle}}
  >
    {{yield}}
  </div>
</template> satisfies TOC<HotelChannelPricingEditCellPopoverSignature>;

export default HotelChannelPricingEditCellPopover;
